<template>
  <SheetContainer title="多发音人" desc="长按选中文字，进行设置">
    <div class="popper-btn-list">
      <div class="popper-btn" @click="onSpeakerSelect">
        <img :src="selectedSpeaker.headerImage" alt="" />
        <span class="btn-text">{{ selectedSpeakerName }}</span>
        <span class="arrow-icon"></span>
      </div>
      <div class="popper-btn" @click="onStyleSelect">
        <span class="btn-text">{{ selectedStyleName }}</span>
        <span class="arrow-icon"></span>
      </div>
      <div class="popper-btn" @click="onSpeedSelect">
        <span class="btn-text">{{ selectedSpeed }}x 语速</span>
        <span class="arrow-icon"></span>
      </div>
    </div>
    <div class="popper-btn-list">
      <div class="popper-btn" @click="onPitchSelect">
        <span class="btn-text">{{ selectedPitch }} 语调</span>
        <span class="arrow-icon"></span>
      </div>
    </div>
    <div class="footer-btns">
      <div class="btn active" @click="onConfirm">确定</div>
      <div class="btn" :class="{ removable }" @click="onRemove">移除</div>
    </div>

    <!-- 风格选择 -->
    <StyleSelectPopper
      :visible.sync="showStyle"
      :options="selectedStyleList"
      :value="selectedSpeaker.id"
      @change="onStyleChange"
    />

    <!-- 语速选择 -->
    <SpeedSelectPopper
      :visible.sync="showSpeeds"
      :value="selectedSpeed"
      @change="onSpeedChange"
    />

    <!-- 语调选择 -->
    <PitchSelectPopper
      :visible.sync="showPitch"
      :value="selectedPitch"
      @change="onPitchChange"
    />
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import StyleSelectPopper from "@/views/index/components/style-select-popper/style-select-popper.vue";
import SpeedSelectPopper from "@/views/index/components/speed-select-popper/speed-select-popper.vue";
import PitchSelectPopper from "@/views/index/components/pitch-select-popper/pitch-select-popper.vue";
import { toast } from "@/utils/util";
import $ from "jquery";
import { isEqual } from "lodash-es";
import { customCollectEvent } from '@/utils/collect';

const LAST_MULTI_SPEAKER = "lastMultiSpeaker";
function MultiSpeakerValue({ speaker, speed, pitch }) {
  return {
    speakerId: speaker.id,
    speed,
    pitch,
  };
}
export default {
  components: {
    SheetContainer,
    StyleSelectPopper,
    SpeedSelectPopper,
    PitchSelectPopper,
  },
  props: {
    sheetVisible: {
      type: Boolean,
      default: false,
    },
    value: {
      // 选中值信息
      type: [String, Object],
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
    speakerUtils: {
      type: Object,
      default: null,
    },
    defaultChooseSpeaker:{
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      selectedValue: "", // 当前选中的值，未选中或者清除时值为""

      selectedSpeaker: null,

      showStyle: false,

      showSpeeds: false,
      selectedSpeed: "1.0",

      showPitch: false,
      selectedPitch: "0",
    };
  },

  computed: {
    removable() {
      return this.selectedValue;
    },
    selectedSpeakerName() {
      return this.selectedSpeaker.name.split("|")[0];
    },
    selectedStyleName() {
      let name = (this.selectedSpeaker.styleName || "默认") + "风格";
      if (name.length > 4) {
        name = name.slice(0, 3) + "...";
      }
      return name;
    },
    selectedStyleList() {
      return this.speakerUtils.getStyleList(this.selectedSpeaker);
    },
  },
  watch: {
    value: {
      immediate: true,
      handler: "init",
    },
    sheetVisible: {
      immediate: true,
      handler: "init",
    },
  },
  methods: {
    init() {
      if (this.sheetVisible) {
        this.selectedValue = "";
        console.log('---this.value',this.value)
        if (this.value) {
          // 点击特效节点打开
          this.selectedSpeaker = this.speakerUtils.getSpeakerById(
            this.value.speakerId
          );
          this.selectedSpeed = this.value.speed;
          this.selectedPitch = this.value.pitch;
          if (this.selectedSpeaker) {
            this.selectedValue = MultiSpeakerValue({
              speaker: this.selectedSpeaker,
              speed: this.selectedSpeed,
              pitch: this.selectedPitch,
            });
          }
        }

        if (!this.selectedSpeaker) {
          this.selectedSpeaker =
            this.speakerUtils.getSpeakerById(
              localStorage.getItem(LAST_MULTI_SPEAKER)
            ) || this.defaultChooseSpeaker;
          this.selectedSpeed = "1.0";
          this.selectedPitch = "0";
        }
      }
    },
    // 校验选中是否合法
    async isValid() {
      const $editor = this.$parent;
      // 校验多发音人 智能分句
      if (
        !(await $editor.validateAutoMute({
          speaker: this.selectedSpeaker,
        }))
      ) {
        return false;
      }
      let currentRange = this.selection.range;
      const speedhover = $(this.selection.el).attr("data-hover");
      if (!this.selection.rangeText && !speedhover) {
        toast("请选中多个汉字");
        return false;
      }
      if (speedhover) {
        currentRange = new Range();
        currentRange.setStartAfter(this.selection.el);
        currentRange.setEndBefore(
          document.querySelector(`#multiSpeakerEnd_${speedhover}`)
        );
      }
      if (currentRange) {
        // 校验当前发音人是否支持特效
        let features = this.selectedSpeaker.speakerFeature || [];

        const support = (authId) =>
          features.some((feature) => feature === authId);
        const effects = {
          1: ["multi-tone", "多音字"], // 多音字
          19: ["stress", "重音"], // 重音
          8: ["pause", "停顿调节"], //停顿
          9: ["mute", "插入静音"], // 静音
          3: ["liandu", "连读"], // 连读
          6: ["localSpeed", "局部变速"], // 局部变速
          12: ["globalMute", "段落静音"], //段落静音
          // 7: ["multiSpeaker", "多人配音"], //多发音人
          4: ["aliasChange", "别名"], //别名
        };
        for (let [authId, [type, name]] of Object.entries(effects)) {
          if ($editor.hasEffectRange(currentRange, type)) {
            if (!support(+authId)) {
              toast(`${this.selectedSpeakerName}暂不支持${name}`);
              return false;
            }
          }
        }
      }
      return true;
    },
    //插入/修改多发音人
    async onConfirm() {
      localStorage.setItem(LAST_MULTI_SPEAKER, this.selectedSpeaker.id);
      if (!(await this.isValid())) return;
      let speedhover = $(this.selection.el).attr("data-hover");
      const value = MultiSpeakerValue({
        speaker: this.selectedSpeaker,
        speed: this.selectedSpeed,
        pitch: this.selectedPitch,
      });
      const speakerName2 = this.selectedSpeaker.name.split("|")[0];
      const speaker = this.selectedSpeaker;
      if (speedhover) {
        let effectParam = {
          effectName: "multiSpeaker",
          idName: "hover",
          id: speedhover,
          innerEffectName: "multiSpeakerInner",
        };

        let $el = $(this.selection.el);
        const currentSpeaker = $el.attr("data-speaker");
        const currentSpeed = +$el.attr("data-speed");
        const currentPitch = +$el.attr("data-pitch");
        if (
          speaker.speaker !== currentSpeaker ||
          +value.speed !== currentSpeed ||
          +value.pitch !== currentPitch
        ) {
          toast("修改成功");
        }

        this.$emit("updateNode", effectParam, {
          speed: value.speed,
          pitch: value.pitch,
          speakerName: speaker.name,
          speakerName2,
          speakerId: value.speakerId,
          gender: speaker.gender,
          speaker: speaker.speaker,
          speakerSource: speaker.source,
        });
      } else {
        this.updateValue(
          MultiSpeakerValue({
            speaker: this.selectedSpeaker,
            speed: this.selectedSpeed,
            pitch: this.selectedPitch,
          })
        );
      }

      // 检查更新智能分句是否支持状态
      this.checkUpdateAutoMute();

      // 埋点
      customCollectEvent("editor_duofayinren", {
        name: speakerName2,
        style: this.selectedSpeaker.styleName,
        speed: value.speed,
        tone: value.pitch,
      });
    },
    // 删除多发音人
    onRemove() {
      let speedhover = $(this.selection.el).attr("data-hover");
      let effectParam = {
        effectName: "multiSpeaker",
        idName: "hover",
        id: speedhover,
        innerEffectName: "multiSpeakerInner",
      };
      this.$emit("updateNode", effectParam, {}, "delete");

      // 检查更新智能分句是否支持状态
      this.checkUpdateAutoMute();
    },
    // 检查更新智能分句是否支持状态
    checkUpdateAutoMute() {
      this.$nextTick(() => {
        const $editor = this.$parent;
        $editor.checkUpdateAutoMute();
      });
    },
    // 更新多发音人
    updateValue(newValue) {
      if (!isEqual(newValue, this.selectedValue)) {
        this.selectedValue = newValue;
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);
      }
    },

    // 选择发音人
    onSpeakerSelect() {
      const $speaker = this.$parent.$refs.speakerSelectPopper;
      $speaker
        .open({
          speaker: this.selectedSpeaker,
          validateSpeakerAutoMute: false,
        })
        .then(({ speaker }) => {
          this.selectedSpeaker = speaker;
          this.selectedSpeed = "1.0";
          this.selectedPitch = "0";
        })
        .catch(() => {
          // 取消 或 未改变
        });
    },

    // 选择语速
    onSpeedSelect() {
      this.showSpeeds = true;
    },
    onSpeedChange(value) {
      this.selectedSpeed = value;
    },

    // 选择风格
    onStyleSelect() {
      this.showStyle = true;
    },
    onStyleChange({ option }) {
      this.selectedSpeaker = option;
    },

    // 选择语调
    onPitchSelect() {
      this.showPitch = true;
    },
    onPitchChange(value) {
      this.selectedPitch = value;
    },
  },
};
</script>
<style lang="less" scoped>
.popper-btn-list {
  margin-bottom: 32px;
  display: flex;
  justify-content: flex-start;
}
.popper-btn {
  display: flex;
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 70px;
  font-size: 28px;
  font-family: 'HarmonyOS_Sans_SC';
  font-weight: 400;
  color: #333333;
  border-radius: 10px;
  border: 2px solid #cedcef;
  &:not(:first-child) {
    margin-left: 32px;
    white-space: nowrap;
  }
  img {
    flex: none;
    margin-right: 12px;
    width: 52px;
    height: 52px;
    border-radius: 100%;
    overflow: hidden;
  }

  &:first-child .btn-text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .arrow-icon {
    flex: none;
    margin-left: 8px;
    width: 24px;
    height: 24px;
    display: inline-block;
    background-image: url("~@/assets/images/icon_header_arrow.png");
    background-size: contain;
  }
}
.footer-btns {
  margin: 72px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 328px;
    height: 64px;
    background: #f4f4f4;
    border-radius: 10px;
    font-size: 26px;
    font-family: 'HarmonyOS_Sans_SC';
    font-weight: 400;
    color: #b8b8b8;

    &.active {
      background: #3583fb;
      color: #fff;
    }

    &.removable {
      background: #dceafe;
      color: #333333;
    }
  }
}
</style>